import { createActionDuck } from "../helpers/action";
import createItemFetcher from "../helpers/item";
import { createNotificationsEpic } from "../helpers/notifications";
const computePanelId = config => {
    const { scenario, program, mode, panelName, panel } = config;
    const finalPanel = panel ? panel : panelName;
    return `${scenario}_${program}_${mode}_${finalPanel}`;
};
const computeGetRefStatusUrl = config => {
    const { scenario, program, panelName, workspace, mode } = config;
    const program_lc = program.toLowerCase();
    let position = "";
    let fixedPanelName = panelName.slice();
    let url;
    if (panelName.indexOf("_") !== -1) {
        position = panelName.substring(panelName.indexOf("_") + 1);
        fixedPanelName = panelName.substring(0, panelName.indexOf("_"));
        url = `/api/v1/dat/${scenario}/${workspace}/${program_lc}/${mode}/${fixedPanelName}/${position}/refStatus`;
    }
    else {
        url = `/api/v1/dat/${scenario}/${workspace}/${program_lc}/${mode}/${panelName}/refStatus`;
    }
    return url;
};
export const panelRefStatusDuck = createItemFetcher(computeGetRefStatusUrl, "PANEL_REF_STATUS", computePanelId);
const computeSetOperationalUrl = config => {
    const { scenario, program, panelName, workspace, mode } = config;
    const program_lc = program.toLowerCase();
    let position = "";
    let fixedPanelName = panelName.slice();
    let url;
    if (panelName.indexOf("_") !== -1) {
        position = panelName.substring(panelName.indexOf("_") + 1);
        fixedPanelName = panelName.substring(0, panelName.indexOf("_"));
        url = `/api/v1/dat/${scenario}/${workspace}/${program_lc}/${mode}/${fixedPanelName}/${position}/operational`;
    }
    else {
        url = `/api/v1/dat/${scenario}/${workspace}/${program_lc}/${mode}/${panelName}/operational`;
    }
    return url;
};
const computeRestoreOperationalUrl = config => {
    const { scenario, program, panelName, workspace, mode } = config;
    const program_lc = program.toLowerCase();
    let position = "";
    let fixedPanelName = panelName.slice();
    let url;
    if (panelName.indexOf("_") !== -1) {
        position = panelName.substring(panelName.indexOf("_") + 1);
        fixedPanelName = panelName.substring(0, panelName.indexOf("_"));
        url = `/api/v1/dat/${scenario}/${workspace}/${program_lc}/${mode}/${fixedPanelName}/${position}/restoreOperational`;
    }
    else {
        url = `/api/v1/dat/${scenario}/${workspace}/${program_lc}/${mode}/${panelName}/restoreOperational`;
    }
    return url;
};
const computePanelSetOperational = (config) => ({
    url: `${computeSetOperationalUrl(config)}`,
    method: "POST"
});
export const panelSetOperationalDuck = createActionDuck("PANEL_SET_OPERATIONAL", computePanelSetOperational, computePanelId);
panelSetOperationalDuck.middleware = panelSetOperationalDuck.middleware.concat(createNotificationsEpic(panelSetOperationalDuck.ActionKeys, "save operational panel", () => ""));
const computePanelRestoreOperational = (config) => ({
    url: `${computeRestoreOperationalUrl(config)}`,
    method: "POST"
});
export const panelRestoreOperationalDuck = createActionDuck("PANEL_RESTORE_OPERATIONAL", computePanelRestoreOperational, computePanelId);
panelRestoreOperationalDuck.middleware = panelRestoreOperationalDuck.middleware.concat(createNotificationsEpic(panelRestoreOperationalDuck.ActionKeys, "restore operational panel", () => ""));
//# sourceMappingURL=operationalPanels.js.map